/**
 * makeVFXBacking — adapts a runtime's GUID-addressed VFX subsystem to the entity-addressed
 * {@link VFXBacking} that `engine.vfx` consumes. The DI seam (mirrors makePhysicsBacking):
 * resolves the subsystem lazily + maps entity↔GUID via the live Level, no-ops when absent.
 */

import type { EntityHandle } from "./IEngineContext";
import type { VFXBacking } from "./modules/VFXScriptApi";

/** The GUID-addressed VFX surface both runtimes' VFX subsystem implement structurally. */
export interface GuidVFXApi {
  play(guid: string): void;
  stop(guid: string): void;
  spawn(guid: string, count: number): void;
  setLoop(guid: string, loop: boolean): void;
  isComplete(guid: string): boolean;
  setVariable(guid: string, name: string, value: unknown): boolean;
}

export function makeVFXBacking(
  getApi: () => GuidVFXApi | null,
  entityToGuid: (entity: EntityHandle) => string | null,
): VFXBacking {
  return {
    play: (e) => {
      const a = getApi();
      const g = entityToGuid(e);
      if (a && g) a.play(g);
    },
    stop: (e) => {
      const a = getApi();
      const g = entityToGuid(e);
      if (a && g) a.stop(g);
    },
    spawn: (e, count) => {
      const a = getApi();
      const g = entityToGuid(e);
      if (a && g) a.spawn(g, count);
    },
    setLoop: (e, loop) => {
      const a = getApi();
      const g = entityToGuid(e);
      if (a && g) a.setLoop(g, loop);
    },
    isComplete: (e) => {
      const a = getApi();
      const g = entityToGuid(e);
      return a && g ? a.isComplete(g) : false;
    },
    setVariable: (e, name, value) => {
      const a = getApi();
      const g = entityToGuid(e);
      return a && g ? a.setVariable(g, name, value) : false;
    },
  };
}
